import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';
import { FcuIDs } from '@helpers/ams-data-fram-constants';
import { FcuStatus } from '@models/system-status';
import { SystemStatusService } from '@service/system-status.service';

@Component({
    selector: 'app-fcu-list-status-indicator',
    templateUrl: './fcu-list-status-indicator.component.html',
    styleUrls: ['./fcu-list-status-indicator.component.scss'],
    standalone: false,
})
export class FcuListStatusIndicatorComponent implements OnInit, OnChanges {
    @Input() isReceivingData: boolean;
    @Input() fcuSrc: string;
    @Input() fcu: FcuStatus;
    @Output() onSelectFcu: EventEmitter<FcuStatus> = new EventEmitter<FcuStatus>();

    fcuIndex: number;

    constructor(private systemStatusService: SystemStatusService) {}

    ngOnInit(): void {
        if (this.fcuSrc) {
            this.fcuIndex = FcuIDs[this.fcuSrc];
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.fcuSrc && this.fcuSrc) {
            this.fcuIndex = FcuIDs[this.fcuSrc];
        }
    }

    hasAlarms(): boolean {
        if (!this.isReceivingData) return false;
        return this.systemStatusService.getAlarmCounts(this.fcu) > 0;
    }

    selectFcu() {
        this.onSelectFcu.emit(this.fcu);
    }
}
